module.exports = "https://web-assets-production.autolist.com/_next/static/images/truck-4e973104e0e75337bbf87fb3f822cf1e.jpg";